import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Bleed, Inline, Stack } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';

import { TeamCardWrapper } from '../team-card-wrapper';

const AvatarMemberSkeleton = () => (
	<Bleed inline="space.050">
		<Skeleton width="24px" height="24px" borderRadius="50%" testId="skeleton" isShimmering />
	</Bleed>
);

const DescriptionTextSkeleton = () => (
	<Skeleton width="100%" height="10px" testId="skeleton" isShimmering />
);

export const TeamCardSkeleton = (): React.JSX.Element => {
	return (
		<TeamCardWrapper id="skeleton">
			<Stack space="space.150">
				<Inline spread="space-between">
					<Skeleton width="32px" height="32px" borderRadius="4px" testId="skeleton" isShimmering />
					<Inline space="space.0">
						<AvatarMemberSkeleton />
						<AvatarMemberSkeleton />
						<AvatarMemberSkeleton />
						<AvatarMemberSkeleton />
					</Inline>
				</Inline>
				<Stack space="space.075">
					<Skeleton width="70px" height="16px" testId="skeleton" isShimmering />
					<Skeleton width="70px" height="12px" testId="skeleton" isShimmering />
				</Stack>

				<Stack space="space.050">
					<DescriptionTextSkeleton />
					<DescriptionTextSkeleton />
					<DescriptionTextSkeleton />
				</Stack>
			</Stack>
		</TeamCardWrapper>
	);
};
